import _ from 'lodash'

const docTypeIcons = {
  'completion'                    : '/completion-oil.svg',
  'commingle'                     : '/commingle-1.svg',
  'increased density'             : '/increased-density.svg',
  'lease'                         : '/lease.svg',
  'location exception'            : '/location-exception.svg',
  'permit to drill'               : '/permit.svg',
  'plugging'                      : '/plugged-and-abandoned.svg',
  'pooling'                       : '/pooling.svg',
  'spacing'                       : '/spacing.svg',
  'transfer of operator'          : '/transfer.svg',
  'cert of comp & trans authority': '/transfer.svg',
  'unitization'                   : '/unitization.png'
}

class ResultsGridDirective {
  constructor(config,
              $analytics,
              SearchParametersService,
              RecordFilterService,
              SubscriptionService,
              UpgradeTeaser,
              CurrentUserService,
              DetailResultService) {

    this.config                  = config
    this.$analytics              = $analytics
    this.UpgradeTeaser           = UpgradeTeaser
    this.CurrentUserService      = CurrentUserService
    this.RecordFilterService     = RecordFilterService
    this.SubscriptionService     = SubscriptionService
    this.SearchParametersService = SearchParametersService

    this.templateUrl = 'results-grid.partial.html'
    this.scope = {
      running: '=',
      data: '='
    }
  }

  controller($scope,
             $element,
             $attrs,
             $analytics,
             SearchParametersService,
             RecordFilterService,
             SubscriptionService,
             UpgradeTeaser,
             DetailResultService,
             CurrentUserService,
             config) {
    // TODO: scope handling in this directive is a hack. We should move a bunch
    // of this controller and link code to a separate controller class, then use
    // controllerAs to give it an alias so we can reference it from the view
    // without having to use $scope. See
    // http://blog.thoughtram.io/angularjs/2015/01/02/exploring-angular-1.3-bindToController.html
    // for an example.

    // TODO: this should be a top-level function, but because of scoping issues
    // I pulled this in here.
    function registerMethods(gridApi) {
      var titleCase = (s) => {
        return s
          .replace(/_/g, ' ')
          .split(' ')
          .map((i) => i[0].toUpperCase() + i.substring(1))
          .join(' ')
      }

      var format = (summary) => {
        return _
          .pairs(summary)
          .map((x) => [titleCase(x[0]), x[1]])
      }

      gridApi.expandable.on.rowExpandedStateChanged(null, (row) => {
        $scope.numberOfExpandedRows += row.isExpanded ? 1 : -1
        var formattedSummary = format(row.entity.summary)
        row.entity.subData = formattedSummary

        $analytics.eventTrack(
          'Record Row Expanded',
          {'Record Id': row.entity.vaultDataId}
        )
      })

      gridApi.pagination.on.paginationChanged(null, (pageNum, pageSize) => {
        $scope.currentGridPage = pageNum
        $scope.paginationHeightTrigger = pageNum + pageSize
        gridApi.expandable.collapseAllRows()
      })

      gridApi.grid.registerRowsProcessor(docTypeFilter, 200)

      $scope.filter = (doc) => {
        $scope.docFilter = doc
        RecordFilterService.currentDocFilter = doc
        gridApi.grid.refresh()
        gridApi.expandable.collapseAllRows()
      }

      $scope.track = (eventType) => {
        $analytics.eventTrack(
          'Export Button Interaction',
          {eventType: eventType}
        )
      }

      $scope.openModal = () => {
        UpgradeTeaser.openModal()
      }

      $scope.filterLease = (lease) => {
        $scope.leaseFilter = lease
        RecordFilterService.currentLeaseFilter = lease
        gridApi.grid.refresh()
        gridApi.expandable.collapseAllRows()
      }
    }

    function prepareModalData(config, recordDetail) {
      const price = recordDetail.numberOfPages || '1 per page'
      const relevantTrackingData = {
        county: recordDetail.county,
        docType: recordDetail.typeOfDocument
      }

      return {
        template: config.template,
        urls: config.urls,
        price: price,
        trackingData: relevantTrackingData
      }
    }

    function setModalConfig(modalConfig) {
      UpgradeTeaser.setConfig(modalConfig)
      return modalConfig.trackingData
    }

    function openModal(trackingData) {
      UpgradeTeaser.openModal()
      return trackingData
    }

    function atlaSubscriberSummariesDescription(exportCount) {
      if( exportCount > 5000 ) {
        return `Export the first 5000 results`
      }
      return `Export ${exportCount} results`
    }
    
    function solAnnualSubscriberSummariesDescription(exportCount) {
      if( exportCount > 1000 ) {
        return `Export the first 1000 results`
      }
      return `Export ${exportCount} results`
    }

    $scope.exportableSummariesDescription = () => {
      if ( $scope.exportableSummaries ) {
        const exportCount = $scope.exportableSummaries.length
        return userHasAtla ?
          atlaSubscriberSummariesDescription(exportCount) :
          solAnnualSubscriberSummariesDescription(exportCount)
      }
    }

    $scope.openExportModal = () => {
      const exportModalConfig = {
        template: 'only-first-thousand-results.partial.html',
        summaries: $scope.exportableSummaries,
        headers: $scope.exportableSummaryHeaders
      }
      UpgradeTeaser.setConfig(exportModalConfig)
      UpgradeTeaser.openModal()
    }

    function trackEvent(trackingData) {
      $analytics.eventTrack('TXFile Modal Appearance', {
        county : trackingData.county,
        docType: trackingData.docType
      })
    }

    function parsedSourceUrls(entity, purchaseOptions) {   
      return _.reduce(purchaseOptions, parseSourceUrls.bind(this, entity), {})
    }

    function parseSourceUrls(entity, configURLs, purchaseOption) {
      const urlWithPurchaseOption = entity.sourceUrl.replace('{0}', purchaseOption)
      configURLs[purchaseOption] = urlWithPurchaseOption.replace('{1}', config.productName)
      return configURLs
    }

    function toKeys(entity) {
      return _.keys(entity)
    }

    function toStartCase(headerName) {
      return _.startCase(headerName)
    }

    function toSimplifiedData(row) {
      const rowWithSummary = _.merge(row.entity, row.entity.summary)
      return _(rowWithSummary)
             .omit(['icon', 'summary', 'vaultDataId'])
             .value()
    }

    function docTypeFilter(renderableRows) {
      const updatedRows = RecordFilterService.onlyVisibleRows(renderableRows)

      $scope.visibleLeases = _.filter(updatedRows, row => {
        return (row.entity.docType === 'Lease' && row.visible)
      }).length > 0

      $scope.countOfRenderableRows = _.filter(updatedRows, row => {
        return row.visible === true
      }).length

      const simplifiedRows = _(updatedRows)
                               .map(toSimplifiedData)
                               .take(userExportLimit)
                               .value()

      const uniqueKeys = _(simplifiedRows)
                           .map(toKeys)
                           .flatten()
                           .uniq()
                           .value()

      const unifiedSchema = _.reduce(uniqueKeys, (acc, val) => {
        acc[val] = undefined
        return acc
      }, {})

      const toUnifiedSchema = (schema) => (obj) => {
        return _.defaults({}, schema, obj)
      }

      $scope.exportableSummaries = _.map(simplifiedRows, toUnifiedSchema(unifiedSchema))

      $scope.exportableSummaryHeaders = _(uniqueKeys)
                                          .without('$$hashKey')
                                          .map(toStartCase)
                                          .value()
      return updatedRows
    }
    
    
    
    const userHasAtla = CurrentUserService.hasUserRole('rav-u')
 
    const userExportLimit = (userHasAtla ? 6000 : 1000);

    const drillingRecordCallback = (vaultId) => {
      window.semaphoreList = window.semaphoreList || {};
      setTimeout( () => {
        if(window.semaphoreList[vaultId]) {
          return;
        }
        window.semaphoreList[vaultId] = true;
        const expandedRowId = '#expanded-row-' + vaultId;
        const http = new XMLHttpRequest();
        let spudDateElement = document.querySelector(expandedRowId);
        const url = 'https://search.oseberg.io/record/' + vaultId;
        http.open("GET", url);

        const authToken = localStorage.getItem('ose-token');
        http.setRequestHeader('x-auth-token', authToken);
        http.send();

        http.onload = () => {
          const responseData = http.responseText;
          if(!responseData) {
            return;
          }

          const responseObj = JSON.parse(responseData);
          const spudDateString = _.get(responseObj, ['records', 0, 'spud_date'], '-');
          // append to the inner HTML of the spud date item
          let htmlString = '<span class="attribute">Spud Date: </span><span>' + spudDateString + '</span>';
          window.semaphoreList[vaultId] = false;
          spudDateElement.innerHTML = htmlString;
        };
  
      }, 100);
      return vaultId;
    }

    const productionCallback = (leaseNumber) => {
      window.semaphoreList = window.semaphoreList || {};
      setTimeout( () => {
        if(window.semaphoreList[leaseNumber]) {
          return;
        }

        window.semaphoreList[leaseNumber] = true;
        const expandedRowId = '#expanded-row-' + leaseNumber;
        const http = new XMLHttpRequest();
        let productionWrapper = document.querySelector(expandedRowId);
        const url = 'https://details.oseberg.io/production/monthly/' + leaseNumber;
        http.open("GET", url);

        const authToken = localStorage.getItem('ose-token');
        http.setRequestHeader('x-auth-token', authToken);
        http.send();
  
        http.onload = () => {
          const responseData = http.responseText;
          if(!responseData) {
            return;
          }
          const responseObj = JSON.parse(responseData);
          let records = responseObj.records;
          let textBlob19 = '';
          productionWrapper.innerHTML = '';

          // calculate what the most recent 2 years are in the data.
          let orderedRecords = _.sortByOrder(records, ['yearMonth'], ['desc']);
          let allDates = _.map(orderedRecords, r => r.yearMonth);
          let top13 = _.take(allDates, 13);
          
          const startYear = top13[0].slice(0,4);
          const endYear = _.last(top13).slice(0, 4);
          

          textBlob19 += '<table class="table well">';
          // iterate the records and build something pretty.
          let headerText19 = '<thead><tr><th>Production Type</th>';
          let tableText19 = '<tbody>';
          let oilRowText19 = '<tr><td>Oil (BBLS)</td>';
          let gasRowText19 = '<tr><td>Gas (MCF)</td>';
          let records2019 = _.filter(records, (r) => r.yearMonth.indexOf(startYear) !== -1);
          records2019 = _.sortByOrder(records2019, ['yearMonth'], ['desc']);
          for(let i = 0; i < records2019.length; ++i) {
            const oil = records2019[i].oilProductionVolume || '-';
            const gas = records2019[i].gasProductionVolume || '-';
            headerText19 += '<th>' + records2019[i].yearMonth + '</th>';
            oilRowText19 += '<td>' + oil + '</td>';
            gasRowText19 += '<td>' + gas + '</td>';
          }
          headerText19 += '</tr></thead>';
          tableText19 += '</tbody></table>';
          oilRowText19 += '</tr>';
          gasRowText19 += '</tr>';

          if(startYear === endYear) {
            productionWrapper.innerHTML = textBlob19 + headerText19 + oilRowText19 + gasRowText19 + tableText19;
            return;
          }
          // do the 2nd year
          let textBlob18 = '';
          textBlob18 += '<table class="table well">';
          // iterate the records and build something pretty.
          let headerText18 = '<thead><tr><th>Production Type</th>';
          let tableText18 = '<tbody>';
          let oilRowText18 = '<tr><td>Oil (BBLS)</td>';
          let gasRowText18 = '<tr><td>Gas (MCF)</td>';
          let records2018 = _.filter(records, (r) => r.yearMonth.indexOf(endYear) !== -1);
          records2018 = _.sortByOrder(records2018, ['yearMonth'], ['desc']);
          for(let i = 0; i < records2018.length; ++i) {
            const oil = records2018[i].oilProductionVolume || '-';
            const gas = records2018[i].gasProductionVolume || '-';
            headerText18 += '<th>' + records2018[i].yearMonth + '</th>';
            oilRowText18 += '<td>' + oil + '</td>';
            gasRowText18 += '<td>' + gas+ '</td>';
          }
          headerText18 += '</tr></thead>';
          tableText18 += '</tbody></table>';
          oilRowText18 += '</tr>';
          gasRowText18 += '</tr>';
          // console.log(productionWrapper);
          
          window.semaphoreList[leaseNumber] = false;
          productionWrapper.innerHTML = textBlob19 + headerText19 + oilRowText19 + gasRowText19 + tableText19 + textBlob18 + headerText18 + oilRowText18 + gasRowText18 + tableText18;
  
        }
      }, 100);
      
      return leaseNumber;
    }
    $scope.subscriptionLevel = 'unknown'
    $scope.gridOptions = {
      enableScrollbars         : false,
      enableRowSelection       : false,
      enableFooterTotalSelected: false,
      enableRowHeaderSelection : false,
      multiSelect              : false,
      expandableRowTemplate    : 'results-expanded.partial.html',
      expandableRowScope       : {
        searchParameters: SearchParametersService,
        productionCallback: productionCallback,
        drillingRecordCallback: drillingRecordCallback
      },
      expandableRowHeight      : 204,
      enableSelectAll          : false,
      paginationPageSizes      : [25, 50, 100],
      paginationPageSize       : 25,
      showGridFooter           : false,
      selectionRowHeaderWidth  : 35,
      rowHeight                : 35,
      onRegisterApi            : registerMethods,
      data                     : []
    }
  }

  link($scope, $element, $attrs) {
    this.getSubscriptionInfo($scope)
    this._dataUpdated($scope, $scope.data)
    this._runningUpdated($scope, $scope.running)
    this.dynamicHeight($scope)
    this._setupSchema($scope)

    $scope.$watch('data', value => {
      this._resetRenderableRows($scope)
      this._dataUpdated($scope, value)
    })
    $scope.$watch('running', value => {
      this._runningUpdated($scope, value)
    })
    $scope.$watchGroup([
      'numberOfExpandedRows',
      'paginationHeightTrigger',
      'docFilter',
      'leaseFilter'], value => {
      this.dynamicHeight($scope)
    })
  }

  _resetRenderableRows($scope) {
    $scope.countOfRenderableRows = 0
  }

  getSubscriptionInfo($scope) {
    const userHasAtla = this.CurrentUserService.hasUserRole('rav-u')
    if (userHasAtla) {
      $scope.subscriptionLevel = 'atla'
      return
    }

    this.SubscriptionService.subscription(
      this._getSubscriptionInfoSuccess.bind(this, $scope),
      this._getSubscriptionInfoFail.bind(this, $scope))
  }

  _getSubscriptionInfoSuccess($scope, s) {
    $scope.subscriptionLevel = s.subscription.plan
  }

  _getSubscriptionInfoFail() {
    console.log("Cannot determine user subscription level.  There might be an issue with the billing endpoint.")
  }

  dynamicHeight($scope) {
    var assignHeight

    const rowHeight = 35
    const expandableRowAdjustment = $scope.expandedRowHeight || 204
    const dataLength = $scope.countOfRenderableRows === 0 ?
      $scope.gridOptions.data.length : $scope.countOfRenderableRows
    const gridHeaderFooterOffset = 80
    const recordsLeft = dataLength
      - (($scope.currentGridPage - 1)
      * $scope.gridOptions.paginationPageSize)
    $scope.numberOfExpandedRows = _.isUndefined($scope.numberOfExpandedRows)
      ? 0 : $scope.numberOfExpandedRows

    if (dataLength < $scope.gridOptions.paginationPageSize) {
      assignHeight = dataLength
    } else if (recordsLeft <= $scope.gridOptions.paginationPageSize) {
      assignHeight = recordsLeft
    } else {
      assignHeight =
        (dataLength / (dataLength / $scope.gridOptions.paginationPageSize))
    }
    assignHeight = assignHeight
        * rowHeight + gridHeaderFooterOffset
        + ($scope.numberOfExpandedRows * expandableRowAdjustment) + 'px'
    $scope.gridHeight = assignHeight
  }

  _setupSchema($scope) {

    $scope.gridOptions.columnDefs = [
      { field: 'docType',
        enableSorting: false,
        enableColumnMenu: false,
        width: 32,
        displayName: 'Doc Icon',
        cellTemplate: '<img class="doctype-image" ng-src="{{row.entity.icon}}"></img>'
      },
      { field: 'legal' },
      { field: 'docType',
        displayName: 'Document Type' },
      { field: 'entity',
        headerTooltip: 'Applicant/Operator/Lessee',
        cellTooltip: row => row.entity.whichEntityType
      },
      { field: 'summary.county', displayName: 'County'},
      { field: 'mapDate', displayName: 'Date', cellFilter: 'date' },
      { field: 'sourceUrl',
        displayName: 'Links',
        width: 64,
        enableSorting: false,
        enableHiding: false,
        enableColumnMenu: false,
        cellTemplate: `
          <div>
            <a
              ng-show="row.entity.sourceUrl"
              target="_blank"
              href="{{row.entity.sourceUrl}}"
              analytics-on="click"
              analytics-event="Record Image Viewed"
              analytics-properties="{recordId: {{row.entity.vaultDataId}} }">
              <img class="grid-image grid-image-a" ng-src="images/chain.png" />
            </a>
            <a
              href="#/detail/{{row.entity.vaultDataId}}"
              analytics-on="click"
              analytics-event="Record Detail Viewed"
              analytics-properties="{recordId: {{row.entity.vaultDataId}} }"
              >
              <img class="grid-image grid-image-b" ng-src="images/eye.png" />
            </a>
          </div>
        `
      }
    ]
  }

  _runningUpdated($scope, running) {
    $scope.queryRunning = !!running
  }

  _toClassification(record) {
    return record.summary.classification
  }

  _toOnlyLeases(record) {
    return record.docType === 'Lease'
  }

  _dataUpdated($scope, data) {
    this._runningUpdated($scope, $scope.running)
    $scope.numberOfExpandedRows = 0

    var dataArray
    if (data === undefined) {
      $scope.noResults = false
      dataArray = []
    } else {
      $scope.noResults = data.length == 0
      dataArray = data
    }

    const updatedRecords    = _.map(dataArray, this._attachImages.bind(this))

    $scope.gridOptions.data = updatedRecords
    $scope.docFilter        = this.RecordFilterService.currentDocFilter
    $scope.leaseFilter      = this.RecordFilterService.currentLeaseFilter

    const filterableDocs  = _.unique(_.pluck(updatedRecords, 'docType'))
    if(filterableDocs.indexOf('Production') > -1) {
      $scope.gridOptions.expandableRowHeight = 452;
    } else {
      $scope.gridOptions.expandableRowHeight = 204;
    }
    const filterableLeaseClassifications =  _(data)
                                            .filter(this._toOnlyLeases)
                                            .map(this._toClassification)
                                            .uniq()
                                            .value()

    $scope.postQueryDocFilterOptions   = this.RecordFilterService.defaultDocFilter.concat(filterableDocs)
    $scope.postQueryLeaseFilterOptions = this.RecordFilterService.defaultLeaseFilter.concat(filterableLeaseClassifications)

    this.dynamicHeight($scope)
  }



  _attachImages(record) {
    _.assign(record, {icon: this._docTypeIcon(record.docType)})
    return record
  }

  _docTypeIcon(docType) {
    var baseDir = this.config.resultsImagePath
    var docTypeNorm = docType.toLowerCase()

    if (docTypeIcons[docTypeNorm]) {
      return baseDir + docTypeIcons[docTypeNorm]
    }
  }
}

ResultsGridDirective.$inject = ['config',
                                '$analytics',
                                'SearchParametersService',
                                'RecordFilterService',
                                'SubscriptionService',
                                'UpgradeTeaser',
                                'CurrentUserService',
                                'DetailResultService']

export default ResultsGridDirective
